<div class="trip-detail-popup-right">
  <img
    src="../../../assets/img/icons8-macos-close-60.png"
    class="close-icons"
    (click)="close()"
  />
</div>

<div class="driver-view" *ngIf="!editTruckCategory">
  <div class="heading">
    <h3>Edit Truck Category</h3>
  </div>
  <mat-divider></mat-divider>
  <form>
    <div class="row m-0 mt-3">
      <div class="col-sm-9">
        <div class="row mtb mr-0 ml-0">
          <div class="col-sm-5">
            <div class="head">Truck Category Name</div>
            <div class="dec">{{ data.truck_category_name }}</div>
          </div>
          <div class="col-sm-7">
            <div class="head">Truck Category Description</div>
            <div class="dec">{{ data.category_description }}</div>
          </div>
        </div>
      </div>
      <div class="col-sm-3">
        <img src="{{ data.category_image }}" class="truckImg" />
      </div>
    </div>
    <div class="row"></div>
    <div class="fixed-btn">
      <button (click)="editDriver()" *ngIf="editButton">Edit</button>
    </div>
  </form>
</div>

<!-- --------------------- Edit Category --------------------- -->

<div *ngIf="editTruckCategory">
  <div class="heading">
    <h3>Edit Truck Category</h3>
  </div>
  <mat-divider></mat-divider>
  <form action="" [formGroup]="editTruckForm" class="admin-forms">
    <div class="input-fileds-container mt-3 category-edit">
      <div class="row">
        <div class="row col-sm-12">
          <div class="row col-sm-12">
            <div class="col-sm-6">
              <div>Truck Category Name</div>
              <div>
                <mat-form-field>
                  <input
                    matInput
                    formControlName="truck_category_name"
                    style="text-transform: capitalize"
                    required
                  />
                  <mat-error>Please Enter Category Name</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-sm-6">
              <div>Truck Category Description</div>
              <div>
                <mat-form-field>
                  <input
                    matInput
                    formControlName="category_description"
                    style="text-transform: capitalize"
                    required
                  />
                  <mat-error>Please Enter Description</mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row imageTruck">
        <div class="col-sm-12 d-flex flex-column align-items-center">
          <img
            src="{{ profileImage }}"
            class="truckImg cursor-pointer"
            alt="Truck Image"
          />
          <div class="image-upload-area mt-2 d-flex align-items-center">
            <a class="replace-text d-flex align-items-center cursor-pointer"
              >
              Replace Truck Image
              <span class="edit-icon ms-2" (click)="uploadImage.click()">
                <i class="bi bi-pencil"></i>
              </span>
            </a>
          </div>
          <input
            #uploadImage
            type="file"
            formControlName="category_image"
            (change)="onChange($event)"
            hidden
          />
        </div>
      </div>
    </div>
    <div class="fixed-btn">
      <button
        (click)="updateTruckCatg($event)"
        [class.spinner]="loading"
        [ngClass]="{ 'button-disabled': loading || !editTruckForm.valid }"
        [disabled]="loading || !editTruckForm.valid"
      >
        Save
      </button>
    </div>
  </form>
</div>
